import {put, takeEvery} from "@redux-saga/core/effects";
import {
    deleteElement,
    deleteElementError, deleteElementSuccess, getAllElement, getAllElementError, GetAllElementPayloadMulti,
    getAllElementSuccess,
    MultimediaElement,
    saveElement, saveElementError, saveElementSuccess
} from "../reducers/Multimedia/MultimediaReducer";
import {CustomFetch, CustomFetchResponse} from "../utils/CustomFetch";
import apiPaths from "../config/apiPaths";
import {openSnackbar} from "../reducers/snackbar/snackbarReducer";
import {all, fork} from "redux-saga/effects";
import {PayloadAction} from "@reduxjs/toolkit";

function* getAllElementSaga() {
    yield takeEvery(getAllElement.type, function* (action: PayloadAction<GetAllElementPayloadMulti>) {
        
        if (!action.payload || !action.payload.pageableDto) {
            console.error("Invalid payload or pageableDto is undefined!");
            yield put({ type: getAllElementError.type });
            return;
        }


        const { pageableDto } = action.payload;
       
        

        try {
            let response: CustomFetchResponse = yield CustomFetch({
                method: "POST",
                url: apiPaths.allMultimedia,
                authenticated: true,
                data: pageableDto,
            });


            if (response.status === 200) {
                yield put({ type: getAllElementSuccess.type, payload: response.data });

            } else {
                yield put({ type: getAllElementError.type });
            }
        } catch (error) {
            console.error("Error in getAllElementSaga:", error);
            yield put({ type: getAllElementError.type });
        }
    });
}

function* saveElementSaga(){
    yield takeEvery(
        saveElement.type,
        function* (action: PayloadAction<MultimediaElement>){
            const savePayload = {
                Type: action.payload.type,
                EntityType: action.payload.entityType,
                EntityId: action.payload.entityId || [],
                  // Optional fields with defaults
            };

    
            // Step 2: Log the payload to verify it matches the expected structure
            let response : CustomFetchResponse = yield
            CustomFetch(
                {
                    method: "POST",
                    url: apiPaths.saveMultimedia,
                    authenticated: true,
                    data: action.payload
                }
            )

            if (response.status === 200){
                yield put(
                    {
                        type: saveElementSuccess.type,
                        payload: response.data
                    }
                )
                yield put({
                    type: openSnackbar.type, payload: {
                        open: true,
                        message: 'Multimedia added successfully',
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        }
                    }
                })
            } else {
                yield put({type: saveElementError.type})
                yield put({
                    type: openSnackbar.type, payload: {
                        open: true,
                        message: 'Multimedia not added successfully',
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        }
                    }
                })
            }
        })
}
function* deleteElementSaga(){
    yield takeEvery(deleteElement.type, function* (action: PayloadAction<{id:string,callback: () => void}>){
        const url = `${apiPaths.deleteMultimedia}/${action.payload.id}`
        let response : CustomFetchResponse = yield CustomFetch(
            {
                method: "DELETE",
                url: url,
                authenticated: true,
                data: action.payload
            })
         if (response.status === 200){

            action.payload.callback()
            yield put(
                {
                    type: deleteElementSuccess.type,
                    payload: response.data.content
                    
                }
            )
            yield put({
                type: getAllElement.type
            })
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Multimedia deleted successfully',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
        } else {
            yield put({ type: deleteElementError.type });
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Multimedia not deleted',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            });
        }


    })
}

export default function* MultimediaSaga(){
    yield all(
        [
            fork(getAllElementSaga),
            fork(saveElementSaga),
            fork(deleteElementSaga)
        ]
    )
}